import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { SafeHtml } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { KebabCasePipe } from "src/app/pipes/kebab-case.pipe";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-bloque-enlaces-noticias",
  imports: [RouterModule, KebabCasePipe, MatIconModule, NgIf, NgFor, SkeletonImageComponent],
  templateUrl: "./bloque-enlaces-noticias.component.html",
  styleUrl: "./bloque-enlaces-noticias.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Componente que muestra los bloque de enlaces o más información laterales en la noticia.
 */
export class BloqueEnlacesNoticiasComponent {
  /**
   * Un array de objetos que contiene los enlaces a las noticias.
   */
  @Input() data: any[] = [];
  @Input() title: string;
  /**
   * Input especializado para el bloque "masInfo" de la noticia.
   */
  @Input() extra: SafeHtml;
  miniSrcDefault: string;

  constructor() {}
  generateMiniSrc(src) {
    this.miniSrcDefault = src.replace(/caratula/i, "caratula_320");
    return this.miniSrcDefault;
  }

  trackByItem(index: number, item: any) {
    return item.id;
  }
}
